// extracted by mini-css-extract-plugin
export default {"vehicle":"Vehicle_vehicle__sh5kg"};